import _Button from "@material-ui/core/esm/Button";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import Debounce from 'react-debounce-component';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import buttonsClasses from 'swag-client-common/styles/buttons.scss';
import { Color } from 'swag-client-common/components/ui/color';
import IncrementNote from 'swag-client-common/components/ui/increment-note';
import getNotificationText from 'swag-common/utils/product/get-notification-text-for-product-quantity.util';
import { CSSTransition } from 'react-transition-group';
import OutOfStockMessage from 'swag-client-common/components/ui/out-of-stock-message';
import SharedItemNote from 'swag-client-common/components/partials/shared-item-note/shared-item-note';
import { Tooltip } from 'swag-client-common/components/info/tooltip/tooltip';
import { Placement } from 'swag-client-common/constants';
import { getProductOutOfStockThreshold } from 'swag-common/utils/product/product.utils';
import { getSupplierInStockQuantityBySize, getStockQuantityToShow } from 'swag-client-common/utils/product.utils';
import { HiddenLabel } from 'swag-client-common/components/hidden-label';
import { DEFAULT_BUTTON } from '../../../../../../constants/styles';
import { PriceBreaksPopup } from '../../../../../popups/price-breaks-popup';
import { UpsellWidget } from '../upsell-widget';
import detailsClasses from '../details/details.scss';
import CSSclasses from './quantity-block-multiple.scss';
import STYLES from './quantity-block-multiple-styles';
import appearAnimClasses from './error-appear.anim.scss';
import { QuantityBlockMultipleTitle } from './components/quantity-block-multiple-title';
const styles = {
  button: _objectSpread({}, DEFAULT_BUTTON, STYLES.button)
};
const tooltipClasses = {
  tooltip: CSSclasses.tooltip,
  popper: CSSclasses.popper
};
const ProductName = props => /*#__PURE__*/React.createElement("div", {
  className: CSSclasses.productName
}, props.children);
const Variants = ({
  variants,
  isQuantityPerSizeEnabled,
  quantityPerSizeInfoMessage,
  size,
  sizeIndex,
  associatedProductIsSelected,
  isAssociatedProduct = false,
  onQuantityChange,
  quantIncrement,
  stockLevelsByVariantSku,
  productIsAlwaysInStock = false,
  outOfStockThreshold,
  skipStockLevelByVariantValidation = false,
  isShared = false,
  sharedQuantitiesLack = null,
  productId,
  isLimitedEdition
}) => {
  const preventFromEnterSubmission = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: detailsClasses.subBlock
  }, variants.map(variant => {
    const {
      name,
      color,
      variantIndex,
      quantities = {}
    } = variant;
    const quantity = quantities[sizeIndex];
    const errorMessage = getNotificationText({
      quantIncrement,
      productIsAlwaysInStock: isLimitedEdition ? false : isLimitedEdition,
      stockLevelsByVariantSku,
      variants: [variant],
      quantityForCurrentItem: quantity,
      skipValidation: skipStockLevelByVariantValidation
    });
    return /*#__PURE__*/React.createElement("div", {
      "data-color-block": name,
      key: variantIndex
    }, (variants.length > 1 || associatedProductIsSelected) && /*#__PURE__*/React.createElement("div", {
      className: classnames(buttonsClasses.blackTextBorderedButton, CSSclasses.buttonContainerLeft, CSSclasses.colorButtonWrapper)
    }, /*#__PURE__*/React.createElement(Color, {
      color: color,
      name: name,
      className: CSSclasses.colorCircle
    }), /*#__PURE__*/React.createElement("span", {
      className: CSSclasses.colorName
    }, name)), /*#__PURE__*/React.createElement("div", {
      className: detailsClasses.errorMessage
    }, /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: appearAnimClasses,
      in: !!(sharedQuantitiesLack !== null && sharedQuantitiesLack !== void 0 && sharedQuantitiesLack[`${productId}:${name}`]),
      unmountOnExit: true,
      timeout: 200
    }, /*#__PURE__*/React.createElement(Debounce, {
      ms: 200
    }, /*#__PURE__*/React.createElement("p", {
      className: detailsClasses.animatedErrorText
    }, sharedQuantitiesLack === null || sharedQuantitiesLack === void 0 ? void 0 : sharedQuantitiesLack[`${productId}:${name}`])))), isQuantityPerSizeEnabled && /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.info
    }, quantityPerSizeInfoMessage), isQuantityPerSizeEnabled ? /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.sizesContainer
    }, size.options.map((sizeName, sizeIndex) => {
      var _variant$sizeSkus;
      const supplierInStockQuantity = getSupplierInStockQuantityBySize({
        isAlwaysInStock: isLimitedEdition ? false : productIsAlwaysInStock || (variant === null || variant === void 0 ? void 0 : variant.isAlwaysInStockVariant),
        variantSizeSkus: (_variant$sizeSkus = variant === null || variant === void 0 ? void 0 : variant.sizeSkus) !== null && _variant$sizeSkus !== void 0 ? _variant$sizeSkus : {},
        currentSizeName: sizeName,
        stockLevelsByVariantSku
      });
      const isOutOfStock = supplierInStockQuantity <= outOfStockThreshold;
      const value = quantities[sizeIndex];
      const grayedOut = isOutOfStock && value === 0 || isShared;
      const inputId = `quantityForSize-${sizeName}-${variantIndex}`;
      return /*#__PURE__*/React.createElement("div", {
        key: sizeIndex,
        className: CSSclasses.sizeItem,
        "data-size-block": sizeName
      }, /*#__PURE__*/React.createElement("span", {
        className: CSSclasses.input
      }, /*#__PURE__*/React.createElement(HiddenLabel, {
        htmlFor: inputId,
        label: `Quantity for ${sizeName} size:`
      }), /*#__PURE__*/React.createElement("input", {
        id: inputId,
        "data-size-input": sizeName,
        className: classnames(CSSclasses.pink, {
          [CSSclasses.grayedOut]: grayedOut,
          [CSSclasses.orange]: isLimitedEdition
        }),
        onKeyPress: preventFromEnterSubmission,
        disabled: grayedOut,
        value: value,
        onChange: e => onQuantityChange(e.target.value, variantIndex, sizeIndex)
      })), /*#__PURE__*/React.createElement("span", {
        "data-label": "Size",
        className: CSSclasses.label
      }, sizeName), /*#__PURE__*/React.createElement(OutOfStockMessage, {
        twoLines: true,
        showCompletelyOutOfStockMessage: true,
        inStockQuantity: getStockQuantityToShow({
          isOutOfStock,
          availableQuantity: supplierInStockQuantity,
          currentQuantity: value,
          skipValidation: skipStockLevelByVariantValidation
        })
      }));
    })) : (variants.length > 1 || isAssociatedProduct) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiddenLabel, {
      htmlFor: "variantTotalQuantity",
      label: "Quantity for variant:"
    }), /*#__PURE__*/React.createElement("input", {
      id: "variantTotalQuantity",
      "data-input": "VariantTotalQuantity",
      className: classnames(CSSclasses.pink, {
        [CSSclasses.orange]: isLimitedEdition
      }),
      value: quantities[sizeIndex],
      onKeyPress: preventFromEnterSubmission,
      onChange: e => onQuantityChange(e.target.value, variantIndex, sizeIndex)
    })), /*#__PURE__*/React.createElement("div", {
      className: detailsClasses.errorMessage
    }, /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: appearAnimClasses,
      in: variants.length > 1 && !!errorMessage,
      unmountOnExit: true,
      timeout: 200
    }, /*#__PURE__*/React.createElement(Debounce, {
      ms: 200
    }, /*#__PURE__*/React.createElement("p", {
      className: detailsClasses.animatedErrorText,
      "data-error": "Increment"
    }, errorMessage)))));
  }));
};
const QuantityBlockMultipleComponent = ({
  number,
  showPriceBreaks,
  productName,
  minQuant,
  variants,
  quantityPerSizeEnabled,
  quantityPerSizeInfoMessage,
  size,
  totalQuantity,
  sizeIndex,
  hasSelectedAssociatedProducts,
  associatedProducts,
  errorMessage,
  boxNotifications,
  label = '',
  onPriceBreakClick,
  onGeneralQuantityChange,
  onSingleQuantityChange,
  onAssociatedProductQuantityChange,
  onStartCollectSizes,
  classes,
  quantIncrement,
  stockLevelsByVariantSku,
  productIsAlwaysInStock,
  outOfStockThreshold,
  sharedItemInfo,
  skipStockLevelByVariantValidation,
  isSharedItemEditing = false,
  sharedQuantitiesLack = null,
  isLimitedEdition,
  productId,
  isCollectSizesAvailable,
  splitOrderMode,
  isCBSMode,
  disablePriceBreaks,
  disablePriceBreaksMessage
}) => {
  const preventFromEnterSubmission = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.wrapper
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.blockHeader
  }, /*#__PURE__*/React.createElement(QuantityBlockMultipleTitle, {
    number: number,
    hasSelectedAssociatedProducts: hasSelectedAssociatedProducts,
    isSharedItemEditing: isSharedItemEditing,
    isLimitedEdition: isLimitedEdition,
    totalQuantity: totalQuantity,
    preventFromEnterSubmission: preventFromEnterSubmission,
    onGeneralQuantityChange: onGeneralQuantityChange,
    label: label,
    minQuant: minQuant,
    isCollectSizesAvailable: isCollectSizesAvailable,
    splitOrderMode: splitOrderMode,
    onStartCollectSizes: onStartCollectSizes,
    isCBSMode: isCBSMode
  }), showPriceBreaks && /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.buttonContainerRight
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: disablePriceBreaksMessage,
    mode: "light",
    placement: Placement.RIGHT,
    classes: tooltipClasses,
    disableHoverListener: !disablePriceBreaks
  }, /*#__PURE__*/React.createElement(_Button, {
    "data-button": "PriceBreaks",
    onClick: onPriceBreakClick,
    disabled: disablePriceBreaks,
    variant: "contained",
    className: classnames(CSSclasses.button, classes.button)
  }, "Price Breaks")), /*#__PURE__*/React.createElement(PriceBreaksPopup, null))), !hasSelectedAssociatedProducts && /*#__PURE__*/React.createElement(SharedItemNote, _extends({
    className: detailsClasses.sharedItemNote,
    isLimitedEdition: isLimitedEdition
  }, sharedItemInfo)), /*#__PURE__*/React.createElement("div", {
    className: detailsClasses.errorMessage
  }, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: appearAnimClasses,
    in: !!errorMessage,
    unmountOnExit: true,
    timeout: 200
  }, /*#__PURE__*/React.createElement(Debounce, {
    ms: 200
  }, /*#__PURE__*/React.createElement("p", {
    className: detailsClasses.animatedErrorText
  }, errorMessage)))), /*#__PURE__*/React.createElement(IncrementNote, {
    quantIncrement: quantIncrement,
    minQuant: minQuant,
    isLimitedEdition: isLimitedEdition
  }), /*#__PURE__*/React.createElement(UpsellWidget, null)), boxNotifications && !!boxNotifications.length && boxNotifications.map((n, i) => /*#__PURE__*/React.createElement("p", {
    key: `box-notification-${i}`,
    className: detailsClasses.warning
  }, n)), /*#__PURE__*/React.createElement("div", {
    "data-block": "MainProduct"
  }, hasSelectedAssociatedProducts && /*#__PURE__*/React.createElement(ProductName, null, productName), hasSelectedAssociatedProducts && /*#__PURE__*/React.createElement(SharedItemNote, _extends({
    className: detailsClasses.sharedItemNote
  }, sharedItemInfo)), /*#__PURE__*/React.createElement(Variants, {
    outOfStockThreshold: outOfStockThreshold,
    productIsAlwaysInStock: productIsAlwaysInStock,
    stockLevelsByVariantSku: stockLevelsByVariantSku,
    variants: variants,
    quantIncrement: quantIncrement,
    isQuantityPerSizeEnabled: quantityPerSizeEnabled,
    quantityPerSizeInfoMessage: quantityPerSizeInfoMessage,
    size: size,
    sizeIndex: sizeIndex,
    onQuantityChange: onSingleQuantityChange,
    associatedProductIsSelected: hasSelectedAssociatedProducts,
    skipStockLevelByVariantValidation: skipStockLevelByVariantValidation,
    isShared: isSharedItemEditing,
    sharedQuantitiesLack: sharedQuantitiesLack,
    productId: productId,
    isLimitedEdition: isLimitedEdition
  })), hasSelectedAssociatedProducts && /*#__PURE__*/React.createElement("div", null, associatedProducts.map(({
    product,
    variants,
    isQuantityPerSizeEnabled,
    size,
    sizeIndex,
    isShared,
    sharedInfo
  }) => /*#__PURE__*/React.createElement("div", {
    "data-related-sizes": product._id,
    key: product._id,
    className: CSSclasses.associatedProductContainer
  }, /*#__PURE__*/React.createElement(ProductName, null, product.name), /*#__PURE__*/React.createElement(SharedItemNote, _extends({
    className: detailsClasses.sharedItemNote
  }, sharedInfo)), !isShared && /*#__PURE__*/React.createElement(Variants, {
    skipStockLevelByVariantValidation: skipStockLevelByVariantValidation,
    outOfStockThreshold: getProductOutOfStockThreshold(product),
    stockLevelsByVariantSku: stockLevelsByVariantSku,
    variants: variants,
    quantIncrement: quantIncrement,
    isQuantityPerSizeEnabled: isQuantityPerSizeEnabled,
    quantityPerSizeInfoMessage: quantityPerSizeInfoMessage,
    size: size,
    sizeIndex: sizeIndex,
    onQuantityChange: onAssociatedProductQuantityChange.bind(null, product._id),
    associatedProductIsSelected: hasSelectedAssociatedProducts,
    isShared: isShared,
    sharedQuantitiesLack: sharedQuantitiesLack,
    productId: product._id,
    isAssociatedProduct: true,
    isLimitedEdition: isLimitedEdition
  })))));
};
export const QuantityBlockMultiple = withStyles(styles)(QuantityBlockMultipleComponent);